import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["map", "select", "viewAlignment"]

  connect() {
    console.log("curriculum2 connected", this.element)
    this.fetchMap()
  }

  fetchMap() {
    const mapTarget = this.mapTarget
    fetch("/images/united-states-map.svg")
      .then((response) => response.text())
      .then((html) => {
        mapTarget.innerHTML = html
        // No need to add click handlers - the SVG now has <a> tags
      })
  }

  onChange(e) {
    const link = this.viewAlignmentTarget
    const selectValue = this.selectTarget.value

    if (!selectValue) {
      link.setAttribute("disabled", "true")
      return
    }

    let state = selectValue.toLowerCase()
    link.removeAttribute("disabled")
    link.disabled = false

    // Set the curriculum URL
    link.href = `/curriculum/${state}`
  }
}
